import { Route } from '@angular/router';
import { attachmentsUploadingWarningGuard } from '@shared/guards/attachments-uploading-warning/attachments-uploading-warning.guard';
import { isFeatureEnabled } from '@core/feature-flag/feature-flag.guard';
import { unsavedWorkOrderChangesGuard } from '@shared/guards/unsaved-work-order-changes/unsaved-work-order-changes.guard';
import { unsavedTyreActivityChangesGuard } from '@shared/guards/unsaved-work-order-changes/unsaved-tyre-activity-changes.guard';
import { ExistingWorkOrderWarningService } from '@app/supplier/work-order/shared/existing-work-order-warning.service';

export const supplierRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'work-orders',
  },
  {
    path: 'activity-catalogue',
    loadComponent: () => import('@app/supplier/activity-catalogue/activity-catalogue.component').then(component => component.ActivityCatalogueComponent),
  },
  {
    path: 'work-orders',
    children: [
      {
        path: '',
        loadComponent: () => import('@app/supplier/work-order/overview/overview.component').then((component) => component.OverviewComponent),
      },
      {
        path: 'add',
        loadComponent: () => import('@app/supplier/work-order/add/add.component').then(component => component.AddComponent),
      },
      {
        path: ':id',
        canDeactivate: [unsavedWorkOrderChangesGuard],
        loadComponent: () => import('@app/supplier/work-order/details/details.component').then(component => component.DetailsComponent),
        providers: [ExistingWorkOrderWarningService],
        children: [
          {
            path: 'activities',
            loadComponent: () => import('@app/supplier/work-order/details/components/activities/activities.component'),
          },
          {
            path: 'activities/switch-tyre-activity',
            loadComponent: () => import('@app/supplier/work-order/details/components/switch-tyre-activity/add/add-switch-tyre-activity.component'),
            canActivate: [isFeatureEnabled('supplier.work-order.add-tyre-activity')],
            canDeactivate: [unsavedTyreActivityChangesGuard],
          },
          {
            path: 'activities/replace-tyre-activity',
            loadComponent: () => import('@app/supplier/work-order/details/components/replace-tyre-activity/add/add-replace-tyre-activity.component'),
            canActivate: [isFeatureEnabled('supplier.work-order.add-tyre-activity')],
            canDeactivate: [unsavedTyreActivityChangesGuard],
          },
          {
            path: 'activities/edit-switch-tyre-activity/:activityId',
            loadComponent: () => import('@app/supplier/work-order/details/components/switch-tyre-activity/edit/edit-switch-tyre-activity.component'),
            canActivate: [isFeatureEnabled('supplier.work-order.edit-tyre-activity')],
          },
          {
            path: 'activities/edit-replace-tyre-activity/:activityId',
            loadComponent: () => import('@app/supplier/work-order/details/components/replace-tyre-activity/edit/edit-replace-tyre-activity.component'),
            canActivate: [isFeatureEnabled('supplier.work-order.edit-tyre-activity')],
          },
          {
            path: 'details',
            loadComponent: () => import('@app/supplier/work-order/details/components/details/details.component'),
          },
          {
            path: 'documents',
            loadComponent: () => import('@app/supplier/work-order/details/components/attachments/attachments.component').then(component => component.AttachmentsComponent),
            canDeactivate: [attachmentsUploadingWarningGuard],
          },
          {
            path: 'vehicle-history',
            loadComponent: () =>
              import('@app/supplier/work-order/details/components/vehicle-history/vehicle-history.component').then(component => component.VehicleHistoryComponent),
          },
          {
            path: '',
            redirectTo: 'activities',
            pathMatch: 'full',
          },
        ],
      },
    ],
  },
  {
    path: 'replacement-transports/:id',
    loadComponent: () => import('@app/supplier/replacement-transports/replacement-transport-request.component'),
  },
  {
    path: 'vehicle-history',
    children: [
      {
        path: '',
        loadComponent: () => import('@app/supplier/vehicle-history/details/details.component').then((component) => component.DetailsComponent),
      },
    ],
  },
];
